import { Form } from 'antd'
import { useTranslation } from 'react-i18next'
import { locales } from '../user/locale'
import { languageOf, useCampaignLocale } from './campaign-locale'
import { MessageTemplate } from './message-template'

// Returns a notice when the start message template is in another language than the campaign.
export function useTemplateLanguageNotice(template?: MessageTemplate) {
    const { t } = useTranslation()
    const form = Form.useFormInstance()
    const locale = useCampaignLocale(form)

    const templateLanguage = template ? languageOf(template.language) : undefined

    if (!template || !templateLanguage || templateLanguage === languageOf(locale)) {
        return undefined
    }

    const templateLocale = locales.find((supportedLocale) => languageOf(supportedLocale) === templateLanguage)

    return t('The start message is in {{templateLanguage}}. The configured conversation language is {{language}}.', {
        templateLanguage: templateLocale ? t(`locales.${templateLocale}`) : template.language,
        language: t(`locales.${locale}`),
    })
}
